// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { query, orderBy, limit } from "firebase/firestore";
import { addDoc, collection, doc, getDocs } from "firebase/firestore";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import store from "../store";
import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
  uploadBytesResumable,
  connectStorageEmulator,
} from "firebase/storage";
import {
  getAuth,
  signInWithPopup,
  connectAuthEmulator,
  GoogleAuthProvider,
} from "firebase/auth";
import { signOut } from "firebase/auth";
import { setDevicePerc } from "../store/actions/forms";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

initializeApp(firebaseConfig);
const auth = getAuth();
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: "select_account",
});
const db = getFirestore();
const storage = getStorage();

// // eslint-disable-next-line no-restricted-globals
// if (location.hostname === "localhost") {
//   console.log(">>>> Local emulator");
//   connectAuthEmulator(auth, "http://localhost:9099");
//   connectFirestoreEmulator(db, "localhost", 8080);
//   connectStorageEmulator(storage, "localhost", 9199);
//   // storage.useEmulator("localhost", 9199);
// }

const upload = async (fileType, filePath, fileContent, gui, min, max) => {
  return new Promise((resolve, reject) => {
    console.log(">>>");
    console.log({ fileType, filePath });
    const storageRef = ref(storage, filePath);

    const metadata = {
      contentType: fileType,
    };

    const uploadTask = uploadBytesResumable(storageRef, fileContent, metadata);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          min + (snapshot.bytesTransferred / snapshot.totalBytes) * (max - min);
        console.log("Upload is " + progress + "% done");
        gui && store.dispatch(setDevicePerc(progress));
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            console.log("default");
            break;
        }
      },
      (error) => {
        reject(error);
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          resolve(downloadURL);
        });
      }
    );
  });
};

let firebaseModule = {
  doSignInWithPoppup: async () => {
    console.log("sign");
    const auth = getAuth();

    try {
      console.log("LOGGING");
      const result = await signInWithPopup(auth, provider);
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      // @ts-ignore
      const token = credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      return user;
    } catch (error) {
      console.log(error);
    }
  },

  doSignOut: () => auth.signOut(),
  // @ts-ignore
  doAddDatabase: async (data) => {
    try {
      const docRef = await addDoc(
        collection(db, `${process.env.REACT_APP_ENV}_sonvi_elements`),
        data
      );
      console.log("Document written with ID: ", docRef.id);
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  },

  uploadFiles: async (data) => {
    const {
      uid,
      audioType,
      audioFileName,
      imageFileName,
      imageType,
      imageFile,
      audioFile,
    } = data;
    try {
      const imageFilePath = `${
        process.env.REACT_APP_ENV
      }/images/${uid}/${new Date().valueOf()}-${imageFileName}`;
      const audioFilePath = `${
        process.env.REACT_APP_ENV
      }/audio/${uid}/${new Date().valueOf()}-${audioFileName}`;
      const imageUrl = await upload(
        imageType,
        imageFilePath,
        imageFile,
        true,
        0,
        50
      );
      const audioUrl = await upload(
        audioType,
        audioFilePath,
        audioFile,
        true,
        50,
        100
      );

      return {
        imageUrl,
        audioUrl,
        audioFileName,
        imageFileName,
        audioType,
        imageType,
      };
    } catch (error) {
      console.log(error);
    }
  },

  queryData: async () => {
    try {
      const citiesRef = collection(
        db,
        `${process.env.REACT_APP_ENV}_sonvi_elements`
      );
      const q = query(citiesRef);
      const querySnapshot = await getDocs(q);
      let elementsList = [];
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        elementsList.push(doc.data());
      });
      return elementsList;
    } catch (error) {
      console.log(error);
    }
  },
};

export default firebaseModule;
